export function formatPhoneNumberForHref(phoneNumber: string) {
  return phoneNumber.replace(/[()-\s]/g, "")
}
